export enum PRODUCT_TEMPLATE_FIELD_TYPE {
  STRING = 'STRING',
  NUMBER = 'NUMBER',
  FILE = 'FILE',
  CI = 'CI',
}

export interface IProductTemplateField {
  name: string;
  order?: number;
  required: boolean;
  field: PRODUCT_TEMPLATE_FIELD_TYPE;
}

export interface IProductTemplate {
  _id?: string;
  name: string;
  fields: IProductTemplateField[];
  createdAt?: Date;
}
